'use strict';

module.exports = (function () {
  class CurrentLocation {
    static initClass() {
      this.prototype.templates = {
        currentLocationMarker: require('../current_location_marker.html.mustache'),
      };
      this.prototype.onNewLocationCallbacks = null;
      this.prototype.shouldTriggerNewLocation = false;
      this.prototype.errorCount = 0;
    }

    constructor({ $el, $error, map }) {
      this.errorHandler = this.errorHandler.bind(this);
      this.successHandler = this.successHandler.bind(this);
      this.$el = $el;
      this.$error = $error;
      this.map = map;
      this.onNewLocationCallbacks = [];
      this.$error.click(() => this.$error.fadeOut('fast'));
    }

    setMap(map) {
      this.map = map;
      this.centerMap();
      return this.createOrUpdateMarker();
    }

    centerMap() {
      const coords = this.get();

      if (coords == null || this.map == null) {
        return;
      }

      return void this.map.setCenter(
        new google.maps.LatLng(coords.lat, coords.lon)
      );
    }

    showError(text) {
      this.$error.text(text);
      this.$error.fadeIn('fast');
      this.errorCount += 1;
      const errorCountDup = this.errorCount;
      return setTimeout(() => {
        if (errorCountDup !== this.errorCount) {
          return;
        }

        return void this.$error.fadeOut('fast');
      }, 10000);
    }

    errorHandler(err) {
      this.$el.removeClass('searching');
      this.showError(
        I18n.t(
          'js.modules.offers_map.current_location.error.you_have_disabled_geolocation'
        )
      );
      return this.triggerNewLocation(err);
    }

    triggerNewLocation(err, position) {
      return this.onNewLocationCallbacks.map(cb => {
        cb(err, position);
      });
    }

    onNewLocation(cb) {
      this.onNewLocationCallbacks.push(cb);
    }

    createOrUpdateMarker() {
      const coords = this.get(); // Do not try to create or update the marker unless the map has been loaded.

      if (
        coords == null ||
        this.map == null ||
        (typeof google !== 'undefined' && google !== null
          ? google.maps
          : undefined) == null
      ) {
        return null;
      }

      const currentPosition = new google.maps.LatLng(coords.lat, coords.lon);

      if (this.marker != null) {
        this.marker.setPosition(currentPosition);
      } else {
        this.$marker = $(this.templates.currentLocationMarker.render());
        this.marker = new RichMarker({
          position: currentPosition,
          map: this.map,
          draggable: false,
          shadow: false,
          content: this.$marker[0],
        });
      }

      this.$marker.removeClass('accuracy-30 accuracy-60 accuracy-90');
      const { accuracy } = coords;

      if (accuracy >= 30 && accuracy < 60) {
        return this.$marker.addClass('accuracy-30');
      } else if (accuracy >= 60 && accuracy < 90) {
        return this.$marker.addClass('accuracy-60');
      } else {
        return this.$marker.addClass('accuracy-90');
      }
    }

    successHandler(position) {
      this.$el.removeClass('searching');
      this.$el.addClass('active');
      this.coords = {
        lat: position.coords.latitude,
        lon: position.coords.longitude,
        accuracy: position.accuracy,
      };

      if (this.shouldTriggerNewLocation) {
        // We only trigger a new position event the first time we get the location.
        // We then continue to watch for location changes and we update the marker position,
        // but without triggering a callback to move the map every time.
        this.shouldTriggerNewLocation = false;
        this.centerMap();
        this.triggerNewLocation(null, {
          lat: position.coords.latitude,
          lon: position.coords.longitude,
        });
      }

      return this.createOrUpdateMarker();
    }

    get() {
      if (this.watchPositionId == null || this.coords == null) {
        return null;
      }

      return this.coords;
    }
  }
  CurrentLocation.initClass();
  return CurrentLocation;
})();
